import { apiStd } from './apiClient.js';

/**
 * List tenant users (POST /v1/user/list).
 * Typical body: `{ tenantUuid, page, page_size, order_by, order_direction, search?: { keyword } }`.
 * Response: `{ body: UserRow[], meta: { totalItems, totalPages, currentPage, perPage, hasNext, hasPrevious } }`.
 *
 * @param {Record<string, unknown>} body
 * @returns {Promise<{ body?: unknown[], meta?: Record<string, unknown>, statusCode?: number }>}
 */
export const listTenantUsers = (body) => apiStd.post('/v1/user/list', body);

/**
 * Deactivate one or more users.
 *
 * @param {Record<string, unknown>} body
 * @returns {Promise<unknown>}
 */
export const deactivateUser = (body) => apiStd.post('/v1/user/deactivate', body);

/**
 * Reactivate user(s).
 *
 * @param {Record<string, unknown>} body
 * @returns {Promise<unknown>}
 */
export const activateUser = (body) => apiStd.post('/v1/user/activate', body);
